module.exports = __webpack_public_path__ + "static/media/profil-cycle.74841318.svg";